module.exports = __webpack_public_path__ + "img\\pad_img2.4d6fd11c.png";